/**
 * Copyright © Ircam Amplify 2024-2026
 */
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.css'
import { captchaFetch } from './utils'

declare global {
  interface Window {
    AwsWafIntegration: any
    AwsWafCaptcha: any
    fetch: any
    shouldShowCaptcha: boolean
  }
}

window.fetch = new Proxy(window.fetch, {
  apply: async function (target, that, args) {
    const modalOverlay = document.getElementById('modalOverlay')
    if (args[0]?.href?.includes('cognito') && modalOverlay) {
      if (window.AwsWafIntegration) {
        let token
        if (window.shouldShowCaptcha) token = await captchaFetch()
        else token = await window.AwsWafIntegration.getToken()
        args[1].headers['x-aws-waf-token'] = token
      }
    }

    return target.apply(that, args)
  },
})

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
)
